import { Typography } from "@mui/material";

function NotFound() {
  return <Typography variant="h6">No data found</Typography>;
}

export default NotFound;
